import { on } from '../helpers/utils';
import cssClasses from '../helpers/cssClasses';
import {setCookie, getCookie} from '../helpers/cookies';

document.addEventListener('DOMContentLoaded', function () {
  var storeLoc = window.location.host.split('.')[1]
    ? window.location.host.split('.')[0]
    : false;


  document.querySelectorAll('.store-locator-select').forEach((item) => {
    const span = item.querySelector('[js-store-locator="button"] span');



    if (!span) {
      if (storeLoc == 'it') {
        setSelectValue(item, 'Italy');
      } else if (storeLoc == 'ie') {
        setSelectValue(item, 'Republic of Ireland');
      } else if (storeLoc == 'row') {
        setSelectValue(item, 'Rest of World');
      } else if (storeLoc == 'de') {
        setSelectValue(item, 'Germany');
      } else if (storeLoc == 'fr') {
        setSelectValue(item, 'France');
      } else if (storeLoc == 'us') {
        setSelectValue(item, 'United States');
      } else {
        setSelectValue(item, 'United Kingdom');
      }
    } else {
      if (storeLoc == 'it') {
        span.innerText = 'Italy';
      } else if (storeLoc == 'ie') {
        span.innerText =
        'Republic of Ireland';
      } else if (storeLoc == 'row') {
        span.innerText = 'Rest of World';
      } else if (storeLoc == 'de') {
        span.innerText = 'Germany';
      } else if (storeLoc == 'fr') {
        span.innerText = 'France';
      } else if (storeLoc == 'us') {
        span.innerText = 'United States';
      } else {
        span.innerText = 'United Kingdom';
      }
    }

  });

  const selectors = {
    container: '[js-store-locator="select"]',
  };

  const nodeSelectors = {
    container: document.querySelectorAll(selectors.container),
  };

  nodeSelectors.container.forEach((item) => {
    on('change', item, (event) => updateStore(event));
  });

  function setSelectValue(target, value) {
    const option = target.querySelector(`[data-title="${value}"]`);

    if (option) {
      target.querySelector(`[data-title="${value}"]`).selected = true;
    }
  }

  function updateStore(event) {
    setCookie('Karmoon_Location', 'is-set', 300);
    updateURL(event)
  }

  function updateURL(event) {
    const url = event.target.value;
    window.location.assign(url)
  }
});

/**
 * Export default Location
 */
export default () => {

  const selectors = {
    modal: document.querySelector('[js-location-modal="container"]'),
    close: document.querySelector('[js-location-modal="close"]'),
  };

  function searchCountry() {
    if (typeof geoip2 !== 'undefined') {
      geoip2.country(geolocation);
    } else {
      console.log(`🗺️ Location: No GEOIP 🛑`);
    }
  }

  function geolocation(geoipResponse) {
    checkRedirect(geoipResponse.country.iso_code || 'blank');
  };


  function checkRedirect(geoCountry) {
    console.log(geoCountry);

    if (theme.features.location == geoCountry) {
      setCookie('Karmoon_Location', geoCountry, 300);
      return;
    } else {
      selectors.modal.classList.add(cssClasses.active);
    }
  }

  function closeBar() {
    selectors.close.addEventListener('click', function (){
      selectors.modal.classList.add(cssClasses.hidden);
      setCookie('Karmoon_Location', 'is-closed', 300);
    });
  }

  function init() {
    console.log(`🗺️ Location: Loaded`);
    checkCookie();
  }

  function checkCookie() {
    const hasBeenSet = getCookie('Karmoon_Location');

    if(hasBeenSet) {
      return;
    } else {
      searchCountry();
      closeBar();
    }
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
